import type { WaadooIconName } from '../ui/icons/waadooIcons';

/** The French titles the app gives the catalog entity page's contents. */
export const ENTITY_TAB_TITLES = {
  overview: 'Aperçu',
  documentation: 'Documentation',
} as const;

/**
 * The icon of an entity page's tab, by the tab's id — the content's path as
 * the catalog gives it, with or without its slashes: `/` for the overview
 * (catalog), `docs` (techdocs), `/kubernetes` (kubernetes). Undefined for
 * any other content, which keeps its label alone. A path changed through
 * app-config (`app.extensions`, `config.path`) loses its icon.
 */
const ENTITY_TAB_ICONS: Readonly<Record<string, WaadooIconName>> = {
  '': 'entityOverview',
  docs: 'documentation',
  kubernetes: 'kubernetes',
};

export function entityTabIcon(id: string): WaadooIconName | undefined {
  return ENTITY_TAB_ICONS[id.replace(/^\/+|\/+$/g, '')];
}

/**
 * Whether a tab is the Kubernetes one — on an Odoo project, the admin-only
 * tab of `components/projectKubernetes`, which the project's header shows
 * to the admin tier only. By the content's path, as {@link entityTabIcon}.
 */
export function isKubernetesTab(id: string): boolean {
  return entityTabIcon(id) === 'kubernetes';
}
